enum Gateway {
  None = 0,
  CreditCall = 1,
  Square = 2,
  CardConnect = 3,
  TCC = 4,
  Worldpay = 5,
  LevelUp = 6,
  Givex = 7,
  Heartland = 8,
  AtriumStoredValue = 9,
  Archer = 10,
  Stripe = 11,
  FreedomPayFlash = 12,
  FreedomPayKiosk = 13,
  PinataStoredValue = 14,
  Valutec = 15,
  PaytronixGift = 16,
  OLOGift = 17,
  Elavon = 20,
  VerifonePointCloud = 21,
  OloPayKioskOrderingApi = 22,
  StripeTerminal = 23,
  Eigen = 24,
  Adyen = 25,
  VerifonePointSca = 26,
  EigenStoredValue = 27,
  ChoptLoyalty = 28,
  PinataPay = 29,
  Como = 30,
  PinataPayNative = 31,
  CbordStoredValue = 32,
  OloPayKioskPaymentApi = 33,
  Thanx = 34,
  Punchh = 35,
  PinataLoyalty = 36,
  ParPay = 37,
  Chase = 38,
  SmoothCommerce = 39,
  Spendgo = 40,
  Moneris = 41,
  Starbucks = 42,
  AtriumLoyalty = 43,
  Glory = 44,
  PinataCashMachine = 45,
  LovesRewards = 46,
  PinataCampusCard = 47,
  QuickchargeCampusCard = 48,
}

export { Gateway };
